import React                    from 'react';
import PropTypes                from "prop-types";
import ProfileLiveShowCountdown from './ProfileLiveShowCountdown';
import {getLanguage}            from './ProfileLiveShowHelper';
import {getDate}                from '../../Helper/DateHelper';
import Translations             from '../../../utils/Translations';
import ProfileLiveShowButton    from './ProfileLiveShowButton';
import {getCommonTranslation}   from '../../../utils/TranslationHelper.js';

class ProfileLiveShowItem extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hasStarted: props?.data?.hasStarted || false,
		};

		this.setHasStarted       = this.setHasStarted.bind(this);
	}


	getDate() {
		const start = () => getDate(this.props.data.start);

		const end = () => getDate(this.props.data.end);

		return (
			<div className="profile-live-show__date">
				<div className="profile-live-show__date-item">{`${start().day}.${start().month}.${start().year}`}</div>
				<div className="profile-live-show__date-item">{start().hour}:{start().minutes} - {end().hour}:{end().minutes} {Translations.get('OClock')}</div>
			</div>
		);
	}

	setHasStarted(hasStarted) {
		if (hasStarted) {
			this.props.loadData();
		}
	}

    getDescription() {
		if (this.props.data.description_v2) {
			const descriptionTranslations = this.props.data.description_v2;
			for (let i = 0; i < descriptionTranslations.length; i++) {
				if (descriptionTranslations[i].value && descriptionTranslations[i].language === getLanguage().toLowerCase()) {
					return descriptionTranslations[i].value;
				}
			}
		}

		return Translations.get('cam_shows.info_text');
	}

	getBoughtInfo() {
		if (this.props.data.postBuyInfo) {
			const postBuyInfo = this.props.data.postBuyInfo;
			for (let i = 0; i < postBuyInfo.length; i++) {
				if (postBuyInfo[i].value && postBuyInfo[i].language === getLanguage().toLowerCase()) {
					return postBuyInfo[i].value;
				}
			}
		}

		return Translations.get('cam_shows.info_text_bought');
	}

	getTitle() {
		if (this.props.data.title) {
			const titleTranslations = this.props.data.title;
			for (let i = 0; i < titleTranslations.length; i++) {
				if (titleTranslations[i].value && titleTranslations[i].language === getLanguage().toLowerCase()) {
					return titleTranslations[i].value;
				}
			}
		}

		return Translations.get('LiveShow');
	}

	getImg() {
        const item = this.props.data;
		if (item.imageUrl) {
			return item.imageUrl;
		}

		const filteredSedcards = item.sedcards &&  item.sedcards.filter(item => item.aspectRatio < 2);
		if (filteredSedcards && filteredSedcards.length > 0 && filteredSedcards[this.props.index]) {
			return filteredSedcards[this.props.index].url;
		}
		if (item.sedcard) {
			return item.sedcard.url;
		}
		return item.actorAvatar.url;
	}

	render() {
		const hasTicket = this.props.data.isBought;

		return (
			<div className="profile-live-show">
					<div className="profile-live-show__item">
						{!this.props.isMobile ? <div className="profile-live-show__slogan">{Translations.get('cam_shows.are-you-in').toUpperCase()}</div> :
							<a href={this.props.data.actorLink} className="profile-live-show__name">{this.props.data.actorName}</a>}
						<div className="profile-live-show__img-wrapper">
							<img className="profile-live-show__img" src={this.getImg()} />
						</div>
					</div>
                <div className="profile-live-show__item">
                    {this.props?.data?.isFree && <span className={'badge--filter'}>{getCommonTranslation("for-free").toUpperCase()}</span>}
                    <ProfileLiveShowCountdown
                            start={this.props.data.start}
                            end={this.props.data.end}
                            setHasStarted={this.setHasStarted}
                    />
                    <div className="profile-live-show__title">{this.getTitle()}</div>
                    {this.getDate()}
                    <div className="profile-live-show__info">{hasTicket ? this.getBoughtInfo() : this.getDescription()}</div>
                    {<ProfileLiveShowButton data={this.props.data}
                                            actorId={this.props.data.actorId}
                                            isMobile={this.props.isMobile}
                                            hasStarted={this.state.hasStarted}
                                            onCloseModal={this.props.loadData}
                    />}
                </div>
            </div>
        );
    }
}

ProfileLiveShowItem.propTypes = {
    data:       PropTypes.object,
    isMobile:   PropTypes.bool,
    loadData:   PropTypes.func,
    index:      PropTypes.number,
	activeItem: PropTypes.bool,
};

ProfileLiveShowItem.defaultProps = {
	isMobile:   false,
	activeItem: false,
};

export default ProfileLiveShowItem;




